<script lang="ts">
    import BaseSkeleton from "@components/skeletons/BaseSkeleton.svelte";
    import StackedSkeleton from "@components/skeletons/StackedSkeleton.svelte";
</script>

<div class="gw-rd-vip-tiers-page-widget-skeleton-title">
    <BaseSkeleton width="100%" height="28px" />
</div>
<div class="gw-rd-vip-tiers-page-widget-skeleton-layout">
    {#each { length: 4 } as _, index (index)}
        <div class="gw-rd-vip-tiers-page-widget-skeleton-item">
            <StackedSkeleton gap="22px" count={5} height="6px" />
        </div>
    {/each}
</div>

<style lang="postcss">
    .gw-rd-vip-tiers-page-widget-skeleton-title {
        width: 100%;
        max-width: 320px;
        margin: 0 auto;
    }

    .gw-rd-vip-tiers-page-widget-skeleton-layout {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        gap: var(--gw-rd-space-8);
        justify-content: center;
    }

    .gw-rd-vip-tiers-page-widget-skeleton-item {
        display: flex;
        flex-direction: column;
        flex-basis: 260px;
    }
</style>
